export default __webpack_public_path__ + "static/subset-SuisseIntl-Regular-bb68c2ef017d2c3731cd62bb4725c1c1.woff";